import script from "./AddUsersModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddUsersModal.vue?vue&type=script&setup=true&lang=js"

import "./AddUsersModal.vue?vue&type=style&index=0&id=5f1dfb30&scoped=true&lang=css"

import exportComponent from "/builds/sense/sense-signer/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f1dfb30"]])

export default __exports__